import { ButtonProps } from '@chakra-ui/react';

export const disabledSolid: ButtonProps = {
  bgColor: '#E6E6E6',
  color: 'neutralBlack.500',
  fontWeight: '700',
  _disabled: { opacity: 1, cursor: 'not-allowed' },
};
